export default "/fonts/Urbanist-Medium.ttf?8ac3a860ce667ec267b7b5e44ae92833";